import * as actionTypes from "./actionTypes";

export const loginRequest = params => ({
	type: actionTypes.LOGIN_REQUEST,
	params
});

export const logoutRequest = () => ({
	type: actionTypes.LOGOUT_REQUEST
});

export const changePasswordRequest = params => ({
	type: actionTypes.CHANGE_PASSWORD_REQUEST,
	params
});

export const checkTokenLogin = params => ({
	type: actionTypes.CHECK_TOKEN_LOGIN,
	params
});

export const registerAction = params => ({
	type: actionTypes.REGISTER_ACTION,
	params
});

export const createNewPasswordAction = params => ({
	type: actionTypes.CREATE_NEW_PASSWORD_ACTION,
	params
});

export const validatePasswordAction = params => ({
	type: actionTypes.VALIDATE_PASSWORD_ACTION,
	params
});

export const deleteAccountAction = params => ({
	type: actionTypes.DELETE_ACCOUNT_ACTION,
	params
});

export const cancelDeleteAccountAction = params => ({
	type: actionTypes.CANCEL_DELETE_ACCOUNT_ACTION,
	params
});

export const onLoginWithFaceIdAction = params => ({
	type: actionTypes.ON_LOGIN_WITH_FACE_ID_ACTION,
	params
});

export const offLoginWithFaceIdAction = params => ({
	type: actionTypes.OFF_LOGIN_WITH_FACE_ID_ACTION,
	params
});

export const checkRegisterDeviceAction = params => ({
	type: actionTypes.CHECK_REGISTER_DEVICE_ACTION,
	params
});

export const approvedStatusDeviceAction = params => ({
	type: actionTypes.APPROVED_STATUS_DEVICE_ACTION,
	params
});
